import { render, staticRenderFns } from "./transferOrder.vue?vue&type=template&id=5242977d&scoped=true"
import script from "./transferOrder.vue?vue&type=script&lang=js"
export * from "./transferOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242977d",
  null
  
)

export default component.exports